import { useDispatch, useSelector } from 'react-redux';
import { buildStandaloneFileViewerUrl } from 'utils/navigationUtils';
import { useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  updateConf,
  updateFile,
  updateModalOpen,
  updateSearchQuery
} from '../slice/fileViewerSlice';
import useConf from './useConf';
import { useGetConfigurationQuery } from '../services/applicationApi';
import { getSearchFormValue, openContent } from '../utils/entityUtils';

export const useFileViewer = (viewName) => {
  const dispatch = useDispatch();
  const { getValue: conf } = useConf(useGetConfigurationQuery);
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

  const locationPathname = useLocation().pathname;

  const fileViewerSpecificConf = !locationPathname.includes('/details/')
    ? conf(`${viewName}.fileViewer`, {})
    : conf(`${viewName}.details.fileViewer`, {});

  const fileViewerConf = {
    ...conf('fileViewer'),
    ...fileViewerSpecificConf
  };
  const searchState = useSelector((state) => state.search);

  const getViewerDisplayMode = () => {
    let viewerDisplayMode = fileViewerConf?.mode;
    if (viewerDisplayMode === 'inline' && isMdDown) {
      viewerDisplayMode = 'modalPanel';
    }
    return viewerDisplayMode;
  };

  const displayFile = (file) => {
    if (conf('fileViewer', null) != null) {
      handleFileViewerMode(file);
    } else {
      openContent(file.contentId);
    }
  };

  function getFileViewerSearchQuery(viewName) {
    switch (viewName) {
      case 'search':
        return getSearchFormValue('content');
      case 'globalSearch':
        return searchState.globalSearchQuery;
      default:
        return '';
    }
  }

  function handleFileViewerMode(file) {
    const fileCopy = { ...file };
    // Prevents from cycle
    delete fileCopy.parent;

    dispatch(updateFile(fileCopy));
    dispatch(updateConf(fileViewerConf));
    dispatch(updateSearchQuery(getFileViewerSearchQuery(viewName)));

    const viewerDisplayMode = getViewerDisplayMode();
    if (viewerDisplayMode === 'tab') {
      handleFileViewerTabMode(file.hash);
    } else if (viewerDisplayMode === 'inline') {
      // Do nothing
    } else {
      handleFileViewerModalMode();
    }
  }

  function handleFileViewerTabMode(hash) {
    // open the file viewer in a new tab
    openFileViewerTab(hash);
  }

  function openFileViewerTab(hash) {
    const newWindow = window.open(
      buildStandaloneFileViewerUrl(hash),
      '_blank',
      'noopener,noreferrer'
    );
    if (newWindow) newWindow.opener = null;
  }

  function handleFileViewerModalMode() {
    // open the file viewer in modal
    dispatch(updateModalOpen(true));
  }

  return { displayFile, getViewerDisplayMode };
};
